/**
 * Home Page Component Styling
 */
import { useEffect, useState } from "react";

import { HomePageContainer } from "./styling/homePage.styles";
import Navbar from "@/features/static/navbar/Navbar";
import HomePagePresentation from "./presentation/homePage.presentation";
import { Footer } from "@/features";

const HomePage = () => {
  const [isScrolling, setIsScrolling] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      // Check if the page is being scrolled
      const scrollTop = window.scrollY;
      setIsScrolling(scrollTop > 0);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <HomePageContainer blur={isScrolling}>
      <Navbar className="nav" />
      <HomePagePresentation />
      <Footer />
    </HomePageContainer>
  );
};

export default HomePage;
